import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
export const auditEntitySchema = z.enum(['event', 'task']);
export const auditActionSchema = z.enum(['create', 'update', 'delete', 'toggle_done']);
export const auditLogSchema = z.object({
    id: idSchema,
    entity_type: auditEntitySchema,
    entity_id: idSchema,
    action: auditActionSchema,
    actor_id: idSchema,
    brand_id: idSchema.nullable(),
    payload: z.unknown().nullable(),
    created_at: isoDateTimeSchema,
});
//# sourceMappingURL=audit.js.map